module.exports = __webpack_public_path__ + "assets/img/00024.0f619c20.png";